import { useCallback, useEffect, useState } from "react";
import {
  ExtraActionsWrapper,
  Product,
  ProductActionButton,
  ProductActionsWrapper,
  ProductAddToCart,
  ProductCountAction,
  ProductFavButton,
  ProductImage,
  ProductMetaWrapper,
  ProductImageWrap,
} from "../styles/product";

import { Stack, Tooltip, Typography, Box } from "@mui/material";

import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import ProductMeta from "./ProductMeta";
import ProductDetail from "./productdetail";
import useDialogModal from "./useDialogModal";
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import '../App.css'
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { RemoveProductFromCart, GetProductsInCartByUserId, AddProductToCart, UpdateProduct } from "../utils/productInCart";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { ADD_ITEM } from "../features/productInCartSlice";
import { GetProductsByCategoryId } from "../utils/product"
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import ProductButtons from "./ProductButtons";
import ProductDetailsDialog from "./ProductDetailsDialog";
import FavoritesList from "./Favorites";
import { addFavorite, removeFavorite } from "../features/favoritesSlice";
import { resolveImage } from "./images.js";
import ProductVariationPicker from "./ProductVariationPicker";
import ProductName from "./ProductName";
import ProductPrice from "./ProductPrice";



export default function SingleProductDesktop({ width, product, matches }) {

  // const [ProductDetailDialog, showProductDetailDialog, closeProductDialog] = useDialogModal(ProductDetail);

  const [showOptions, setShowOptions] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedVariations, setSelectedVariations] = useState({});


  const dispatch = useDispatch();
  const favorites = useSelector((state) => state.favorites);

  const isFavorite = favorites.some(fav => fav.id === product.id);

  const handleMouseEnter = () => {
    setShowOptions(true);
  };

  const handleMouseLeave = () => {
    setShowOptions(false);
  };

  const handleAddToFavorites = () => {
    if (isFavorite) {
      dispatch(removeFavorite(product));
    } else {
      dispatch(addFavorite(product));
    }
  };

  const isOutOfStock = product.quantity === 0;
  const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";

  const resolveImgSrc = (img) => {
    if (!img) return null;
    if (img instanceof File) return URL.createObjectURL(img);
    const path = String(img).replace(/\\/g, "/"); // ליתר ביטחון אם הגיעו backslashes
    if (path.startsWith("http") || path.startsWith("//")) return path;
    return `${API_BASE}${path}`; // הופך "/       /..." ל־"https://localhost:7010/uploads/..."
  };


  const basePrice = Number(product.price) || 0;

  const selectedExtra =
    Number(selectedVariations?.Color?.extraPrice ?? selectedVariations?.Size?.extraPrice ?? 0) || 0;

  const displayPrice = selectedExtra > 0 ?  selectedExtra : basePrice;
  const selectedImage =
  selectedVariations?.Color?.image ||
  selectedVariations?.Size?.image ||
  product.image;
  
  console.log("selectedImage:", selectedImage);
console.log("final image src:", resolveImgSrc(selectedImage));


  return (
    <>
      <Product
        onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}
      >

        <ProductImageWrap>
          <ProductImage src={resolveImgSrc(selectedImage)} />
        </ProductImageWrap>

  {/* <ProductMeta product={product} matches={matches} price={displayPrice} /> */}

      <ProductName product={product} matches={matches} />
        <ProductVariationPicker
          productId={product.id}
          onChange={setSelectedVariations}
        />
        <ProductPrice price={displayPrice} matches={matches} />

        {/* <ProductFavButton isfav={isFavorite ? 1 : 0} onClick={handleAddToFavorites}>
          <FavoriteIcon color={isFavorite ? "secondary" : "action"} />
        </ProductFavButton> */}

        {/* <ProductFavButton isfav={0}>
          <FavoriteIcon />
        </ProductFavButton> */}
        {/* <IconButton aria-label="delete" onClick={() => RemoveProductFromCart(item.id)}>
          <DeleteIcon />
        </IconButton> */}
        <ProductActionsWrapper data-show={showOptions || matches}>
          {/* <Stack direction={matches ? 'row' : 'column'}>

            <ProductActionButton onClick={() => setOpen(true)}>
              <Tooltip title="מסך מלא">
                <FitScreenIcon color="primary" />
              </Tooltip>
            </ProductActionButton>
            <ProductDetailsDialog
              product={product}
              open={open}
              setOpen={setOpen}
              fullScreen
              sx={{ '& .MuiDialog-paper': { maxWidth: '100%', maxHeight: '100%' } }}
            ></ProductDetailsDialog>
          </Stack> */}
        </ProductActionsWrapper>

      

        {/* <Box sx={{ mt: "auto", width: "100%" }}> */}
        <ProductButtons product={product} selectedVariations={selectedVariations}></ProductButtons>
        {/* </Box> */}

        {/* {isOutOfStock && (
          <Typography variant="h6" color="error">
            אזל מהמלאי
          </Typography>
        )} */}

      </Product>



      {/* <FavoritesList /> */}

    </>
  );
}